const LiveUrl = "https://upticker.dmms.io";
// const Prod = "https://production.uptickerapp.com/";

// const StaggingUrl = "https://staging.uptickerapp.com";

export const baseUrl = LiveUrl;
